<script lang="ts">
  import { page } from "$app/stores";
  import Link from "$components/link.svelte";
  import { locale } from "$lib/services/i18n";
  // import Navigation from "$components/navbar/index.svelte";
  // import FooterComponent from "$components/footer/index.svelte";
  import type { LayoutData } from "./$types";

  export let data: LayoutData;
  const { nav: navData, footer, locale: detectedLocale } = data;
  locale.set(detectedLocale);
</script>

<header class="header">
  <!-- <Navigation {navData} /> -->
</header>

<!-- Body -->
<main class="container">
  <h1>{$page?.error?.message}</h1>
  <p>
    An error has occured, please contact us on the <Link href="/contact-us">contact us</Link> page if you are still having
    trouble accessing this page
  </p>

  <a role="button" href="/">Go back to homepage</a>
</main>

<svelte:head>
  <title>Football Ticket Pad</title>
</svelte:head>

<!-- <FooterComponent {footer} /> -->

<style lang="scss">
  .header {
    min-height: 90px;
  }

  .container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  :global(a) {
    text-decoration: underline;
  }
</style>
